<section class="quizz_sc">
  <div class="quiz_header">
    <div class="container">
      <div class="quiz_head_grid">
        <div class="lt hd_4">
          <h2>{{title}}</h2>
          <small>Attempt #{{attemptCount}}</small>
        </div>
        <div class="rt">
          <p>Overall Exam Time: <span class="c_primary">{{ displayTime() }}</span></p>
          <!-- <div class="knob-wrapper">
            <p-knob
              [(ngModel)]="secondsValue"
              [min]="0"
              [max]="60"
              [strokeWidth]="4"
              [readonly]="true"
              [size]="70"
              valueColor="#00A63E"
              rangeColor="#D3D3D5"
            >
            </p-knob>
            <div class="knob-label">
              {{ formatTime(secondsValue) }}
            </div>
          </div> -->
          <p-button variant="outlined" color="primary"  (onClick)="exitTest()">
            <img src="{{ assetsConst.exitIcon }}" alt="icon" />Exit Exam
          </p-button>
        </div>
      </div>
      <div class="progress_bar">
        <notchmark-custom-progress
          [progressValue]="progressValue()"
          trackColor="#EBEBEB"
          primaryColor="#D3CF6E"
        />
      </div>
    </div>
  </div>

  <main class="quiz_content">
    <router-outlet></router-outlet>
  </main>
  <!-- <footer class="quiz_footer">
    <div class="container">
      <ul class="quiz_detail_list">
        <li>Subject: <strong> Physics</strong></li>
        <li>Difficulty: <strong> Advanced</strong></li>
      </ul>
      <ul class="quiz_ending">
        <li>49 questions remaining</li>
        <li>Answered: 0/50</li>
      </ul>
    </div>
  </footer> -->
</section>
